import React, { useState, useEffect, useCallback } from 'react'

const DESKTOP_MQ = '(min-width: 992px)'

function LeftSidebar() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(DESKTOP_MQ).matches
  })

  useEffect(() => {
    const mq = window.matchMedia(DESKTOP_MQ)
    const onChange = () => setIsDesktop(mq.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  const expanded = isDesktop || mobileOpen
  const toggle = useCallback(() => setMobileOpen((o) => !o), [])

  return (
    <nav
      className={`sidebar-nav${expanded ? ' sidebar-nav--expanded' : ''}`}
      aria-label="Типы QR кодов"
    >
      <button
        type="button"
        className="sidebar-nav__toggle"
        onClick={toggle}
        aria-expanded={expanded}
        aria-controls="sidebar-nav-panel"
        id="sidebar-nav-toggle"
      >
        <span className="sidebar-nav__toggle-label">Типы QR кодов</span>
        <span
          className={`sidebar-nav__chevron${expanded ? ' sidebar-nav__chevron--open' : ''}`}
          aria-hidden
        />
      </button>

      <div
        id="sidebar-nav-panel"
        className="sidebar-nav__panel"
        role="region"
        aria-labelledby="sidebar-nav-toggle"
        hidden={!expanded}
      >
        <h2 className="sidebar-nav__title" id="sidebar-nav-heading">
          QR коды с дизайном
        </h2>
        <ul className="sidebar-nav__list" aria-labelledby="sidebar-nav-heading">
          <li className="sidebar-nav__item">
            <a className="sidebar-nav__link" href="/qr/create/text/">
              Текст
            </a>
          </li>
          <li className="sidebar-nav__item">
            <a className="sidebar-nav__link" href="/qr/create/phone/">
              Номер телефона
            </a>
          </li>
          <li className="sidebar-nav__item">
            <a className="sidebar-nav__link" href="/qr/create/telegram/">
              Telegram
            </a>
          </li>
          <li className="sidebar-nav__item">
            <a className="sidebar-nav__link" href="/qr/create/url/">
              Ссылка
            </a>
          </li>
          <li className="sidebar-nav__item">
            <a className="sidebar-nav__link" href="/qr/create/sbp/">
              СБП
            </a>
          </li>
          <li className="sidebar-nav__item">
            <a className="sidebar-nav__link" href="/qr/create/yamoney/">
              Кошелёк ЮMoney (Яндекс.Деньги)
            </a>
          </li>
          <li className="sidebar-nav__item">
            <a className="sidebar-nav__link" href="/qr/create/perevod/">
              Перевод физ.лицу по номеру
            </a>
          </li>
          <li className="sidebar-nav__item">
            <a className="sidebar-nav__link" href="/qr/create/wifi/">
              Wi-Fi
            </a>
          </li>
          <li className="sidebar-nav__item">
            <a className="sidebar-nav__link" href="/qr/create/calendar-event/">
              Событие, мероприятие
            </a>
          </li>
          <li className="sidebar-nav__item">
            <a className="sidebar-nav__link" href="/qr/create/vcard/">
              Визитка (vCard)
            </a>
          </li>
          <li className="sidebar-nav__item">
            <a className="sidebar-nav__link" href="/qr/create/geo/">
              Геопозиция
            </a>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default LeftSidebar
